export default {
  title: {
    messages: "پیام‌ها",
    messagesManagement: "مدیریت پیام‌ها"
  },
  showMoreButton: "مشاهده پیام‌های بیشتر",
  noMassages: "شما پیامی ندارید",
  readAllButton: "همه را خوانده‌ام"
};
